<div class="mydocma-dialog-container mm-kb-scroll-footer">
  <!--  //header -->
  <div class="mydocma-dialog-header">
    <div class="mydomca-dialog-header-title centered-title">{{'MM.fault.createFault' | translate}}</div>
    <div>
      <button mat-icon-button type="button" (click)="onCancel()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>

  <!--  body -->
  <div class="mydocma-dialog-body pane-body">
    <div class="mm-message-label">
      {{ 'MM.fault.createFaultFromAttachmentText' | translate }}
    </div>
    <div class="attachmentsList" [class.attachmentsListMobile]="(appContainerService.mobileView$ | async)">
      <mydocma-mm-add-attachments-form>
      </mydocma-mm-add-attachments-form>
    </div>
  </div>

<!--  // footer -->

  <div class="mydocma-dialog-footer" *ngIf="!(appContainerService.mobileView$ | async); else mobileFooter">
    <div style="margin-right: 10px">
      <button mat-stroked-button class="mydocma-btn"
              (click)="onCancel()">
        {{'MM.general.button.cancel' | translate}}
      </button>
    </div>
    <div>
      <button mat-stroked-button class="mydocma-btn-primary"
              [disabled]="!canNext"
              (click)="next()">
        {{'MM.general.button.next' | translate}}
      </button>
    </div>
  </div>
  <ng-template #mobileFooter>
    <div class="mobile-pane-footer">
      <div style="margin-right: 10px">
        <button mat-stroked-button (click)="onCancel()" class="mydocma-btn">
          {{'MM.general.button.cancel' | translate}}
        </button>
      </div>
      <div style="margin-right: 10px">
        <button mat-stroked-button class="mydocma-btn-primary"
                [disabled]="!canNext"
                (click)="next()">
          {{'MM.general.button.next' | translate}}
        </button>
      </div>
    </div>
  </ng-template>

</div>
